<<template>

    <el-dialog lock-scroll :modal-append-to-body="false" :append-to-body="true" :title="$lang('附件列表')" :close-on-click-modal="false"
    :visible.sync="showDialog" @close="closeDialog" width="703px">
    <div>
      <show-file-list :value="fileDataUrl || []" />
      <!-- <avue-form :option="option" v-model="formData" ref="form" :loading="loading" @submit="handleSubmit" /> -->
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShowModdia: {
      type: Boolean,
      default: false
    },
    fileDataUrl: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      fileUrl: this.fileDataUrl,
      showDialog: false
    }
  },
  watch: {
    'isShowModdia': {
      handler(o) {
        this.showDialog = o
        console.log(o)
      }
    }
  },
  methods: {
    closeDialog(e) {
      console.log(e)
      this.$emit('close', this.showDialog)
    }
  }
}
</script>
